<template>
  <v-container id="trips" fluid tag="section">
    <v-btn-toggle rounded style="float: left; background: transparent">
      <v-btn v-if="false" small :color="tab === 2 ? 'secondary' : 'grey'" @click="
        tab = 2;
      search();
      ">
        <h3 style="padding-right: 20px">
          <div style="width: 20px; height: 12px; float: left" v-if="tab !== 2"></div>
          <v-icon v-if="tab === 2" color="white">mdi-check</v-icon>
          <v-badge color="pink" :content="upcomingCnt" :value="upcomingCnt">{{
            $i18n.t("Upcoming")
          }}</v-badge>
        </h3>
      </v-btn>
      <v-btn small :color="tab === 3 ? 'secondary' : 'grey'" @click="
        tab = 3;
      search();
      ">
        <h3 style="padding-right: 20px">
          <div style="width: 20px; height: 12px; float: left" v-if="tab !== 3"></div>
          <v-icon v-if="tab === 3" color="white">mdi-check</v-icon>
          <v-badge color="deep-orange" :content="inserviceCnt" :value="inserviceCnt">{{ $i18n.t("In Service") }}</v-badge>
        </h3>
      </v-btn>
      <v-btn v-if="false" small :color="tab === 4 ? 'secondary' : 'grey'" @click="
        tab = 4;
      search();
      ">
        <h3 style="padding-right: 20px">
          <div style="width: 20px; height: 12px; float: left" v-if="tab !== 4"></div>
          <v-icon v-if="tab === 4" color="white">mdi-check</v-icon>
          {{ $i18n.t("Past") }}
        </h3>
      </v-btn>

      <v-btn small :color="tab === 5 ? 'secondary' : 'grey'" @click="
        tab = 5;
      search();
      ">
        <h3 style="padding-right: 20px">
          <div style="width: 20px; height: 12px; float: left" v-if="tab !== 5"></div>
          <v-icon v-if="tab === 5" color="white">mdi-check</v-icon>
          <v-badge color="pink" :content="podPendingCnt" :value="podPendingCnt">{{ $i18n.t("POD Pending") }}</v-badge>
        </h3>
      </v-btn>

      <v-btn small :color="tab === 1 ? 'secondary' : 'grey'" @click="
        tab = 1;
      search();
      ">
        <h3 style="padding-right: 20px">
          <div style="width: 20px; height: 12px; float: left" v-if="tab !== 1"></div>
          <v-icon v-if="tab === 1" color="white">mdi-check</v-icon>
          {{ $i18n.t("All") }}
        </h3>
      </v-btn>
    </v-btn-toggle>

    <div class="text-right">
      <v-btn color="cyan" @click="showFilter = !showFilter" small>
        <v-badge color="#CD5C5C" :content="filterCnt" :value="filterCnt">
          <v-icon>mdi-filter</v-icon>
        </v-badge>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="secondary" small>
            <h3>
              {{ $i18n.t("Action") }}
              <v-icon>mdi-menu-down</v-icon>
            </h3>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/trip/create'">
            <v-list-item-title>{{ $i18n.t("Create") }}</v-list-item-title>
          </v-list-item>
          <v-list-item @click="uploadT()">
            <v-list-item-title>{{ $i18n.t("Bulk Upload") }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <v-dialog v-model="showFilter" transition="dialog-top-transition">
      <v-card>
        <v-toolbar color="white" fixed class="sticky-top">
          <v-toolbar-title>
            <v-icon>mdi-filter</v-icon>
            {{ $i18n.t("Filter") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-card>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field :label="$i18n.t('GRN/LR No')" class="purple-input" v-model="filters.grnLrNo"
                    @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="6" md="3" lg="2">
                  <v-text-field :label="$i18n.t('Trip No/Title')" class="purple-input" v-model="filters.tripNo"
                    @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="8">
                  <z-client-select :multiple="true" :label="$i18n.t('Client')" class="purple-input" withSelf
                    v-model="filters.client" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-entity-select :multiple="true" :showCorpNames="true" :label="$i18n.t('Client Entity')"
                    class="purple-input" v-model="filters.clientEntity" :corp="filters.client" />
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-entity-select :label="$i18n.t('Vendor Entity')" class="purple-input" v-model="filters.vendorEntity"
                    :corp="corp_id" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="2" lg="2">
                  <z-date-picker :label="$i18n.t('Pickup From Date')" class="purple-input"
                    v-model="filters.pickDateFrom" />
                </v-col>
                <v-col cols="12" sm="4" md="2" lg="2">
                  <z-date-picker :label="$i18n.t('Pickup Till Date')" class="purple-input"
                    v-model="filters.pickDateTill" />
                </v-col>
                <v-col cols="12" sm="4" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Duty Slip No')" class="purple-input" v-model="filters.dutySlipNo"
                    @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <z-vendor-select :multiple="true" :label="$i18n.t('Supplier')" class="purple-input"
                    v-model="filters.supplier" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-autocomplete :label="$i18n.t('Status')" class="purple-input" v-model="filters.status"
                    :items="statusList" item-text="name" item-value="value" clearable></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Invoice No')" class="purple-input" v-model="filters.invoiceNo"
                    @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-autocomplete :label="$i18n.t('Invoice Status')" class="purple-input" v-model="filters.invoiceStatus"
                    :items="invStatusList" item-text="name" item-value="value" clearable></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3">
                  <z-consignor-select :label="'Consignor'" v-model="filters.consignor" :type="1"
                    :addNewLabel="'Add New Consignor'" :isName="true" />
                </v-col>
                <v-col cols="12" md="3">
                  <z-consignor-select :label="'Consignee'" v-model="filters.consignee" :type="2"
                    :addNewLabel="'Add New Consignor'" :isName="true" />
                </v-col>

                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-checkbox :label="$i18n.t('Show Deleted')" v-model="filters.deleted"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-tag-select v-model="filters.tags" :multiple="true" :kind="4" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="my-3">
            <v-card-text>
              Cargo
              <v-row>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Cargo No')" class="purple-input" v-model="filters.cargoNo"
                    @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-country-select :label="$i18n.t('Source Country')" class="purple-input"
                    v-model="filters.cargoScrCountry"></z-country-select>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-city-select :label="$i18n.t('Source City')" class="purple-input" v-model="filters.cargoScrCity"
                    :country="filters.cargoScrCountry"></z-city-select>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-country-select :label="$i18n.t('Destination Country')" class="purple-input"
                    v-model="filters.cargoDstCountry"></z-country-select>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-city-select :label="$i18n.t('Destination City')" class="purple-input" v-model="filters.cargoDstCity"
                    :country="filters.cargoDstCountry"></z-city-select>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Booker Name')" class="purple-input" v-model="filters.bookerName"
                    @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-country-select :label="$i18n.t('Booker Country Code')" class="purple-input" isd hideName
                    v-model="filters.bookerCountryCode"></z-country-select>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Booker Phone')" class="purple-input" type="number"
                    v-model="filters.bookerPhone" @keyup.enter="search" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="my-3">
            <v-card-text>
              Driver / Helper / Vehicle
              <v-row>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Driver Name')" class="purple-input" v-model="filters.driverName" />
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-country-select :label="$i18n.t('Driver Country Code')" class="purple-input" isd hideName
                    v-model="filters.driverCountryCode"></z-country-select>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Driver Phone')" class="purple-input" type="number"
                    v-model="filters.driverPhone" @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Helper Name')" class="purple-input" v-model="filters.helperName"
                    @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-country-select :label="$i18n.t('Helper Country Code')" class="purple-input" isd hideName
                    v-model="filters.helperCountryCode"></z-country-select>
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Helper Phone')" class="purple-input" type="number"
                    v-model="filters.helperPhone" @keyup.enter="search" />
                </v-col>
                <v-col cols="12" sm="3" md="3" lg="3">
                  <z-vehicle-type-select :label="$i18n.t('Vehicle Type')" class="purple-input"
                    v-model="filters.vehicleType" />
                </v-col>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <v-text-field :label="$i18n.t('Vehicle RegNo')" class="purple-input" v-model="filters.regNo"
                    @keyup.enter="search" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card class="my-3">
            <v-card-text>
              Location / Garage
              <v-row>
                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-country-select :label="$i18n.t('Source Country')" class="purple-input"
                    v-model="filters.scrCountry"></z-country-select>
                </v-col>

                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-city-select :label="$i18n.t('Source City')" class="purple-input" v-model="filters.srcCity"
                    :country="filters.scrCountry"></z-city-select>
                </v-col>

                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-country-select :label="$i18n.t('Destination Country')" class="purple-input"
                    v-model="filters.dstCountry"></z-country-select>
                </v-col>

                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-city-select :label="$i18n.t('Destination City')" class="purple-input" v-model="filters.dstCity"
                    :country="filters.dstCountry"></z-city-select>
                </v-col>

                <v-col cols="12" sm="3" md="2" lg="2">
                  <z-name-master-select v-model="filters.zone_id" :label="'Zone'" :type="13" :id="true"
                    :hideAddNew="true" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <!-- <v-card class="my-3">
            <v-card-text>
              Miscellaneous
            </v-card-text>
          </v-card>-->
        </v-card-text>
        <v-card-actions class="sticky-bottom">
          <v-spacer></v-spacer>
          <!-- <v-btn
            color="info"
            class="mr-0"
            fab
            small
            dark
            @click="download()"
            :loading="loading"
          >
            <v-icon>mdi-cloud-download-outline</v-icon>
          </v-btn> -->

          <v-btn color="cyan" class="mr-0" fab small dark @click="downloadT()" :loading="loading">
            <v-icon>mdi-cloud-download-outline</v-icon>
          </v-btn>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn class="mr-0" color="grey darken" fab text small @click="clear(1)"
                style="margin-right: 10px !important" v-on="on">
                <v-icon>mdi-cached</v-icon>
              </v-btn>
            </template>
            <span>{{ $i18n.t("Clear Filter") }}</span>
          </v-tooltip>
          <v-btn color="success" class="mr-0" fab small dark @click="search()" :loading="loading">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <z-transfer-progress kclass="Trip" :reload111="reloadTP">
    </z-transfer-progress>

    <v-btn v-if="!grid.records" class="text-center secondary--text pa-10" text color="primary" style="width: 100%"
      :loading="loading">{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card icon="mdi-map-marker-path" :title="$i18n.t('Trips')" class="px-5 py-3 small-icon"
      v-if="grid.records" color="primary">
      <z-grid-record :grid="grid" class="grid-records" />

      <v-simple-table dense>
        <template v-slot:default>
          <thead class="thead">
            <tr>
              <!-- <th class="text-left" style="width: 40px">
                <v-checkbox
                  v-model="selectAll"
                  style="padding: 0; float: left; width: 30px"
                />
              </th> -->
              <th class="text-left">{{ $i18n.t("GRN/LR No") }}</th>
              <th class="text-left">{{ $i18n.t("Trip No") }}</th>
              <th class="text-left">{{ $i18n.t("Status") }}</th>
              <th class="text-left">{{ $i18n.t("Serving Entity") }}</th>
              <th class="text-left">{{ $i18n.t("Client") }}</th>
              <th class="text-left">{{ $i18n.t("Supplier") }}</th>
              <!-- <th class="text-left">{{ $i18n.t("Body Type") }}</th> -->
              <th class="text-left">{{ $i18n.t("Truck Type") }}</th>
              <th class="text-left">{{ $i18n.t("Date") }}</th>
              <th class="text-left">{{ $i18n.t("Vehicle") }}</th>
              <!-- <th class="text-left">{{ $i18n.t("Driver") }}</th> -->
              <th class="text-left">{{ $i18n.t("Pickup") }}</th>
              <th class="text-left">{{ $i18n.t("Drop") }}</th>
              <th class="text-right" v-if="$ha(750)">
                {{ $i18n.t("Client Due") }}
              </th>
              <th class="text-right" v-if="$ha(750)">
                {{ $i18n.t("Supplier Due") }}
              </th>
              <th class="text-left">{{ $i18n.t("Tag") }}</th>
              <!-- <th class="text-left">Action</th> -->
            </tr>
          </thead>
          <trip-table-row v-for="trip in grid.rows" :key="trip._id" :value="trip" @reload="reload"
            @createInvoicePayload="createInvoice" @invDownload="invDownload" @invEmail="invEmail"
            @changeInvoiceStatus="changeInvoiceStatus" @recreateInvoice="recreateInvoice"
            @deleteInvoice="deleteInvoice" />
        </template>
      </v-simple-table>

      <v-container>
        <v-pagination v-model="grid.page" class="my-4" :length="grid.total" total-visible="10"
          @input="showPage"></v-pagination>
      </v-container>

      <z-invoice-download :payload="payload" :showDialog="showInvoiceDoanload" @closeDialog="closeDialog" :isMail="isMail"
        :invoice="invForMail"></z-invoice-download>
    </base-material-card>

    <z-invoice-create :filters="finalFilters" :showDialog="showCreateInvoice" :selctedTrips="selctedTrips"
      @closeDialog="closeDialog" />

    <z-download-file :requestURL="downloadTripsUrl" :showDialog="showDownloadByTemplateDialog" @closeDialog="closeDialog"
      :kind="1" :forUpload="forUpload" />
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doGetCancel, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import TripTableRow from "@/views/trip/TripTableRow.vue";
import auth from "@/store/user/module/auth";
import axios from "axios";

@Component({
  name: "Trips",
  props: {
    refresh: {
      default: null,
    },
  },
  components: { TripTableRow },
})
export default class Trips extends Vue {
  reloadTP = false;
  grid = { page: 0, rows: null };
  url = "/api/corp/trips/data?sidx=startTime&sord=desc&";
  showFilter = false;
  filterUrl = "";
  filterCnt = 0;
  on = null;
  page = 1;
  rows = 20;
  compact = true;
  selectAll = false;
  tab = 1;
  upcomingCnt = 0;
  podPendingCnt = 0;
  inserviceCnt = 0;
  authContent = null;
  corp_id = null;
  height = window.innerHeight - 200;
  tripStats = null;
  request = null;
  showCreateInvoice = false;
  finalFilters = {};
  selctedTrips = [];
  showInvoiceDoanload = false;
  payload = {};
  invForMail = null;
  isMail = false;
  showDownloadByTemplateDialog = false;

  filters = {
    tripNo: "",
    grnLrNo: "",
    invoiceNo: null,
    /*  amountFrom: null,
     amountTo:null, */
    pickDateFrom: null,
    pickTimeFrom: null,
    pickDateTill: null,
    pickTimeTill: null,

    client: null,
    clientEntity: null,
    costCenter: null,
    supplier: null,
    vendorEntity: null,

    cargoNo: null,

    bookerName: null,
    bookerCountryCode: null,
    bookerPhone: null,

    driverName: null,
    driverCountryCode: null,
    driverPhone: null,

    helperName: null,
    helperCountryCode: null,
    helperPhone: null,

    vehicleType: null,
    regNo: null,

    scrCountry: null,
    dstCountry: null,
    srcCity: null,
    dstCity: null,

    cargoScrCountry: null,
    cargoDstCountry: null,
    cargoScrCity: null,
    cargoDstCity: null,

    tariffType: null,
    dutySlipNo: null,
    consignor: null,
    consignee: null,
  };

  invStatusList = [
    {
      name: "Invoiced",
      value: 1,
    },
    {
      name: "Uninvoiced",
      value: 0,
    },
  ];

  statusList = [
    {
      name: "Open",
      value: 1,
    },
    {
      name: "Supplier Assigned",
      value: 2,
    },
    {
      name: "Ready",
      value: 3,
    },
    {
      name: "In Service",
      value: 4,
    },
    {
      name: "Breakdown",
      value: 5,
    },
    {
      name: "Completed",
      value: 6,
    },
    {
      name: "Cancelled",
      value: 7,
    },
    {
      name: "POD Received",
      value: 20,
    },
    {
      name: "POD Submitted",
      value: 21,
    },
  ];

  createInvoice(_payload) {
    if (!_payload) {
      common.setError("Please select parameters");
      return;
    }
    if (!_payload.client_id) {
      common.setError("Client not provided");
      return;
    }
    if (!_payload.vendor_id) {
      common.setError("Vendor not provided");
      return;
    }
    if (!_payload.invoiceType) {
      common.setError("Type not provided");
      return;
    }
    if (!_payload.trips) {
      common.setError("Select trips");
      return;
    }
    const finalFilters = {};
    finalFilters.client_id = _payload.client_id;
    finalFilters.vendor_id = _payload.vendor_id;
    finalFilters.invoiceType = _payload.invoiceType;
    finalFilters.clientEntity_id = _payload.clientEntity_id;
    finalFilters.vendorEntity_id = _payload.vendorEntity_id;
    this.selctedTrips = _payload.trips;
    this.finalFilters = finalFilters;
    this.showCreateInvoice = true;
  }

  closeDialog(reload) {
    this.showInvoiceDoanload = false;
    this.showCreateInvoice = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
    this.showDownloadByTemplateDialog = false;
    this.showFilter = false;
    common.setLoading(false);
    if (reload) this.reload();
  }

  async changeInvoiceStatus(trip, status) {
    if (status != null && status != undefined && trip.invoice_id) {
      try {
        common.setLoading(true);
        await doGet(
          "/api/invoice/" + trip.invoice_id + "/status/" + status + "/update"
        );
        common.showMessage("Updated");
        common.setLoading(false);
        this.showPage(this.page);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async recreateInvoice(trip) {
    if (trip.invoice_id) {
      try {
        common.setLoading(true);
        await doGet("/api/invoice/" + trip.invoice_id + "/recreate");
        common.showMessage("Updated");
        common.setLoading(false);
        this.showPage(this.page);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  async deleteInvoice(trip) {
    if (trip.invoice_id) {
      try {
        common.setLoading(true);
        await doGet("/api/invoice/" + trip.invoice_id + "/delete");
        common.showMessage("Updated");
        common.setLoading(false);
        this.showPage(this.page);
      } catch (e) {
        common.setLoading(false);
        common.setError(e);
      }
    }
  }

  invDownload(_trip) {
    const _invoice = {
      //TODO change if supplier invoiced
      _id: _trip.invoice_id,
      client_id: _trip.corp_id,
      clientEntity_id: _trip.clientEntity_id,
      vendor_id: _trip.vendor_id,
      vendorEntity_id: _trip.vendorEntity_id,
    };
    let ids = "";
    const clients = [];
    let vendor_id, client_id, vendorEntity_id, clientEntity_id;
    let v_consider = true;
    let c_consider = true;
    let vEntity_consider = true;
    let cEntity_consider = true;
    if (_invoice) {
      ids += _invoice._id;
      clients.push(_invoice.client_id);
      vendor_id = _invoice.vendor_id;
      client_id = _invoice.client_id;
      vendorEntity_id = _invoice.vendorEntity_id;
      clientEntity_id = _invoice.clientEntity_id;
    } else {
      this.grid.rows.forEach(function (t) {
        if (t.selected) {
          ids += t._id + ",";
          clients.push(t.client_id);
          if (v_consider) {
            if (vendor_id == null) {
              vendor_id = t.vendor_id;
            } else if (vendor_id != t.vendor_id) {
              v_consider = false;
            }
          }
          if (c_consider) {
            if (client_id == null) {
              client_id = t.client_id;
            } else if (client_id != t.client_id) {
              c_consider = false;
            }
          }
          if (vEntity_consider) {
            if (vendorEntity_id == null) {
              vendorEntity_id = t.vendorEntity._id;
            } else if (vendorEntity_id != t.vendorEntity._id) {
              vEntity_consider = false;
            }
          }
          if (cEntity_consider) {
            if (clientEntity_id == null) {
              clientEntity_id = t.clientEntity._id;
            } else if (clientEntity_id != t.clientEntity._id) {
              cEntity_consider = false;
            }
          }
        }
      });
    }

    if (!ids) {
      common.setError("Please select invoice(s) to download PDF/Excel");
      return false;
    }

    const payload = { invoice_ids: ids, client_ids: clients };
    if (v_consider) {
      payload.vendor_id = vendor_id;
    }
    if (c_consider) {
      payload.client_id = client_id;
    }
    if (vEntity_consider) {
      payload.vendorEntity_id = vendorEntity_id;
    }
    if (cEntity_consider) {
      payload.clientEntity_id = clientEntity_id;
    }
    this.payload = payload;
    this.showInvoiceDoanload = true;
  }

  invEmail(_trip) {
    this.invForMail = {
      //TODO change if supplier invoiced
      _id: _trip.invoice_id,
      client_id: _trip.corp_id,
      clientEntity_id: _trip.clientEntity_id,
      vendor_id: _trip.vendor_id,
      vendorEntity_id: _trip.vendorEntity_id,
    };
    this.isMail = true;
    this.showInvoiceDoanload = true;
  }

  async uploadT() {
    this.downloadTripsUrl =
      "/api/corp/upload/trips?_search=true" + this.getFilteredUrl();
    this.forUpload = true;
    this.showDownloadByTemplateDialog = true;
  }

  async markCompleted(trip) {
    const data = { trip_id: trip._id };
    try {
      common.setLoading(true);
      await doPost("/api/trip/mark/completed", data);
      common.showMessage("Completed marked");
      common.setLoading(false);
      this.showPage(this.page);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async cancelTrip(trip) {
    const data = { trip_id: trip._id };
    try {
      common.setLoading(true);
      await doPost("/api/trip/mark/cancelled", data);
      common.showMessage("Completed marked");
      common.setLoading(false);
      this.showPage(this.page);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  get loading() {
    return common.loading;
  }

  async fetchStats() {
    try {
      this.tripStats = await doGet("/api/dashboard/trip/stats");
      if (this.tripStats && this.tripStats.general) {
        if (this.tripStats.general.upcoming != null) {
          this.upcomingCnt = this.tripStats.general.upcoming;
        }
        if (this.tripStats.general.inService != null) {
          this.inserviceCnt = this.tripStats.general.inService;
        }
        if (this.tripStats.general.podPending != null) {
          this.podPendingCnt = this.tripStats.general.podPending;
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  async mounted() {
    if (common.restore) {
      const filters = this.$cookies.get("trip.grid.filters");
      if (filters) {
        this.filters = filters;
        this.filterUrl = this.getFilteredUrl();
      }
      const pg = this.$cookies.get("trip.grid.page");
      if (pg) {
        this.page = pg;
      }
    } else {
      this.$cookies.set("trip.grid.filters", "");
    }
    common.setLoading(true);
    try {
      await this.showPage(this.page);
      this.fetchStats();
    } catch (e) {
      common.setError(e.message);
    }
    if (auth.authContent) {
      this.corp_id = auth.authContent.adminOf;
    }
    common.setLoading(false);
  }

  async showPage(page) {
    common.setLoading(true);
    this.page = page;
    if (this.request) {
      this.request.cancel();
    }
    const axiosSource = axios.CancelToken.source();
    this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

    try {
      this.grid = await doGetCancel(
        this.url + "rows=" + this.rows + "&page=" + page + this.filterUrl,
        axiosSource.token
      );
    } catch (e) {
      this.showFilter = false;
      common.setLoading(false);
    }
    this.request = null;
    this.showFilter = false;
    // if (this.grid && this.grid.rows && this.grid.rows.length > 0) {
    //   this.showFilter = false;
    // }
    if (this.grid && this.grid.page != null)
      this.$cookies.set("trip.grid.page", this.grid.page);
    common.setLoading(false);
  }

  async clear() {
    this.filters = {};
    this.page = 1;
    this.search();
  }

  getFilteredUrl() {
    this.filterCnt = 0;
    let url = "";
    if (this.filters.tripNo) {
      url += "&tripNo=" + this.filters.tripNo;
      this.filterCnt++;
    }

    if (this.filters.tags && this.filters.tags.length > 0) {
      const tags = this.filters.tags.join(",");
      url += "&tags=" + tags;
    }

    if (this.filters.amountFrom) {
      url += "&amountFrom=" + this.filters.amountFrom;
      this.filterCnt++;
    }
    if (this.filters.amountTo) {
      url += "&amountTo=" + this.filters.amountTo;
      this.filterCnt++;
    }
    if (this.filters.invoiceNo) {
      url += "&invoiceNo=" + this.filters.invoiceNo;
      this.filterCnt++;
    }
    if (this.filters.grnLrNo) {
      url += "&cargos.lr.number=" + this.filters.grnLrNo;
      this.filterCnt++;
    }

    if (this.filters.pickDateFrom) {
      url += "&pickDateFrom=" + this.filters.pickDateFrom;
      this.filterCnt++;
    }
    if (this.filters.pickTimeFrom) {
      url += "&pickTimeFrom=" + this.filters.pickTimeFrom;
      this.filterCnt++;
    }
    if (this.filters.pickDateTill) {
      url += "&pickDateTill=" + this.filters.pickDateTill;
      this.filterCnt++;
    }
    if (this.filters.pickTimeTill) {
      url += "&pickTimeTill=" + this.filters.pickTimeTill;
      this.filterCnt++;
    }

    if (this.filters.client) {
      url += "&corp_id=" + this.filters.client;
      this.filterCnt++;
    }
    if (this.filters.clientEntity) {
      url += "&clientEntity=" + this.filters.clientEntity;
      this.filterCnt++;
    }
    if (this.filters.costCenter) {
      url += "&costCenter=" + this.filters.costCenter;
      this.filterCnt++;
    }
    if (this.filters.supplier) {
      url += "&supplier_id=" + this.filters.supplier;
      this.filterCnt++;
    }
    if (this.filters.vendorEntity) {
      url += "&vendorEntity_id=" + this.filters.vendorEntity;
      this.filterCnt++;
    }
    if (this.filters.cargoNo) {
      url += "&cargoNo=" + this.filters.cargoNo;
      this.filterCnt++;
    }

    if (this.filters.bookerName) {
      url += "&bookerName=" + this.filters.bookerName;
      this.filterCnt++;
    }
    if (this.filters.bookerCountryCode) {
      url += "&bookerCountryCode=" + this.filters.bookerCountryCode;
      this.filterCnt++;
    }
    if (this.filters.bookerPhone) {
      url += "&bookerPhone=" + this.filters.bookerPhone;
      this.filterCnt++;
    }
    if (this.filters.driverName) {
      url += "&driverName=" + this.filters.driverName;
      this.filterCnt++;
    }

    if (this.filters.driverPhone) {
      if (this.filters.driverCountryCode) {
        url += "&driverCountryCode=" + this.filters.driverCountryCode;
        this.filterCnt++;
      }
      url += "&driverPhone=" + this.filters.driverPhone;
      this.filterCnt++;
    }

    if (this.filters.helperName) {
      url += "&helperName=" + this.filters.helperName;
      this.filterCnt++;
    }
    if (this.filters.helperCountryCode) {
      url += "&helperCountryCode=" + this.filters.helperCountryCode;
      this.filterCnt++;
    }
    if (this.filters.helperPhone) {
      url += "&helperPhone=" + this.filters.helperPhone;
      this.filterCnt++;
    }
    if (this.filters.vehicleType) {
      url += "&vehicleType=" + this.filters.vehicleType;
      this.filterCnt++;
    }
    if (this.filters.regNo) {
      url += "&vehicle.regNo=" + this.filters.regNo;
      this.filterCnt++;
    }

    if (this.filters.scrCountry) {
      url += "&src.country=" + this.filters.scrCountry;
      this.filterCnt++;
    }
    if (this.filters.dstCountry) {
      url += "&dst.country=" + this.filters.dstCountry;
      this.filterCnt++;
    }
    if (this.filters.srcCity) {
      url += "&src.city=" + this.filters.srcCity;
      this.filterCnt++;
    }
    if (this.filters.dstCity) {
      url += "&dst.city=" + this.filters.dstCity;
      this.filterCnt++;
    }

    if (this.filters.zone_id) {
      url += "&zone_id=" + this.filters.zone_id;
      this.filterCnt++;
    }

    if (this.filters.cargoScrCountry) {
      url += "&cargos.src.country=" + this.filters.cargoScrCountry;
      this.filterCnt++;
    }
    if (this.filters.cargoDstCountry) {
      url += "&cargos.dst.country=" + this.filters.cargoDstCountry;
      this.filterCnt++;
    }
    if (this.filters.cargoScrCity) {
      url += "&cargos.src.city=" + this.filters.cargoScrCity;
      this.filterCnt++;
    }
    if (this.filters.cargoDstCity) {
      url += "&cargos.dst.city=" + this.filters.cargoDstCity;
      this.filterCnt++;
    }

    if (this.filters.tariffType) {
      url += "&tariffType=" + this.filters.tariffType;
      this.filterCnt++;
    }
    if (this.filters.deleted) {
      url += "&deleted=" + this.filters.deleted;
      this.filterCnt++;
    }
    if (this.filters.dutySlipNo) {
      url += "&dutySlipNo=" + this.filters.dutySlipNo;
      this.filterCnt++;
    }
    if (this.filters.status) {
      url += "&status=" + this.filters.status;
      this.filterCnt++;
    }
    if (this.filters.invoiceStatus != null) {
      url += "&invoiceStatus=" + this.filters.invoiceStatus;
      this.filterCnt++;
    }
    if (this.filters.consignor != null) {
      url += "&consignor=" + this.filters.consignor;
      this.filterCnt++;
    }
    if (this.filters.consignor != null) {
      url += "&consignor=" + this.filters.consignor;
      this.filterCnt++;
    }
    if (this.tab != 1) {
      if (this.tab == 2) {
        url += "&tab=upcoming";
      } else if (this.tab == 3) {
        url += "&tab=inservice";
      } else if (this.tab == 4) {
        url += "&tab=past";
      } else if (this.tab == 5) {
        url += "&tab=pod_pending";
      }
    }

    return url;
  }

  async search() {
    this.$cookies.set("trip.grid.filters", JSON.stringify(this.filters));
    this.filterUrl = this.getFilteredUrl();
    common.setLoading(true);
    await this.showPage(1);
  }

  downloadTripsUrl = null;
  forUpload = false;
  async downloadT() {
    const downloadUrl =
      "/api/corp/trips/data/download?" + this.getFilteredUrl();
    this.downloadTripsUrl = downloadUrl;
    this.forUpload = false;
    this.showDownloadByTemplateDialog = true;
  }

  async download() {
    try {
      common.setLoading(true);
      const response = await doGet(
        "/api/corp/trips/data/download?" + this.getFilteredUrl()
      );
      common.setLoading(false);
      if (response) {
        common.showMessage(response);
        this.reloadTP = !this.reloadTP;
        this.showFilter = false;
      }
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async reload() {
    this.showPage(this.page);
  }

  // async createInvoice(trip, proforma) {
  //   let url = `/api/invoice/create/trip/${trip._id}/client/${trip.corp_id}/${trip.vendor_id}`;
  //   if (proforma) url = url + "?proforma=true";
  //   common.setLoading(true);
  //   try {
  //     await doGet(url);
  //     common.setLoading(false);
  //     this.showPage(1);
  //   } catch (e) {
  //     common.setLoading(false);
  //     common.setError(e.message);
  //   }
  // }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}

.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.v-card__subtitle,
.v-card__text {
  font-size: 14px;
}

.v-expansion-panel-header--active {
  background-color: aliceblue;
  min-height: 50px !important;
}

tbody:nth-child(even) {
  background: #fafafa;
}

.thead tr th {
  padding: 0 2px !important;
}
</style>
